<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    title="开票详情"
    :visible="detailShow"
    :before-close="closeDetail"
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      slot="title"
      class="dialog-header-title"
    >
      <span class="name">开票并录入</span>
    </div>
    <div
      class="detailContent"
      style="padding: 20px"
    >
      <div class="eachPart">
        <div class="titlePart">

          <span>客户信息</span>
        </div>
        <el-row
          v-for="item in customerInfo"
          :key="item.index"
          gutter="22"
        >
          <el-col
            :span="12"
            class="eachItem"
          >
            <p class="label">{{ item.firstLabel }}:</p>
            <p>{{ item.firstValue }}</p>
          </el-col>
          <el-col
            :span="12"
            class="eachItem"
          >
            <p class="label">{{ item.secondLabel }}:</p>
            <p>
              {{ item.secondValue }}
            </p>
          </el-col>
        </el-row>
      </div>
      <div class="eachPart">
        <div class="titlePart">

          <span>开票信息</span>
        </div>
        <el-row
          v-for="item in invoiceInfo"
          :key="item.index"
          gutter="22"
        >
          <el-col
            :span="12"
            class="eachItem"
          >
            <p class="label">{{ item.firstLabel }}:</p>
            <p>{{ item.firstValue }}</p>
          </el-col>
          <el-col
            :span="12"
            class="eachItem"
          >
            <p class="label">{{ item.secondLabel }}:</p>
            <p>
              {{ item.secondValue }}
            </p>
          </el-col>
        </el-row>
      </div>
      <div class="eachPart">
        <div class="titlePart">
          <span>付款单信息</span>
        </div>
        <small-table
          :tableheader="payHeader"
          :tableData="payInfo"
        />
      </div>
      <div class="eachPart">
        <div class="titlePart">

          <span>开票确认</span>
        </div>
        <el-form
          :model="sub_third_invoice_confirm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="实际开票金额:"
                prop="invoice_amount"
              >
                <form-input
                  :numberVal="sub_third_invoice_confirm.invoice_amount"
                  :disabled="false"
                  @setVal="setVal"
                  :keyName="'invoice_amount'"
                ></form-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="开票人:"
                prop="reviewer_name"
              >
                <el-input
                  v-model="sub_third_invoice_confirm.reviewer_name"
                  type="text"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="联系电话:"
                prop="reviewer_phone"
              >
                <el-input
                  v-model="sub_third_invoice_confirm.reviewer_phone"
                  type="text"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="开票日期:"
                prop="audit_date"
              >
                <el-date-picker
                  v-model="sub_third_invoice_confirm.audit_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开票日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="快递单号:"
                prop="courier_number"
              >
                <el-input v-model="sub_third_invoice_confirm.courier_number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="附件:"
            prop="attachment"
          >
            <eip-attachment
              v-model="sub_third_invoice_confirm.attachment"
              model-name="sub_third_invoice_confirm.attachment"
              :permission="'w'"
              propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
              accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
              limit="10"
              displayType="table"
              isInputEdit=""
              :configAttributes="{}"
              :multiple="true"
              :tenant-id="tenantId"
            >
              <span slot="labeldesc">附件</span>
            </eip-attachment>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <div class="demo-drawer__footer">
      <el-button @click="closeDetail">取消</el-button>
      <el-button
        type="primary"
        @click="submitForm('ruleForm')"
        :loading="loading"
      >保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import smallTable from './smallTable.vue'
import { mapState } from 'vuex'
import FormInput from '../billingCenter/formInput.vue'

export default {
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  components: { smallTable, FormInput },
  props: ['show', 'detailId'],
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!value && value != 0) {
        return callback(new Error('实际开票金额不能为空'))
      }
      setTimeout(() => {
        if (Number(value) < 0) {
          callback(new Error('实际开票金额不能为负数'))
        } else if (Number(value) > 9999999999.99) {
          callback(new Error('实际开票金额不能大于9999999999.99'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      drawerSize: '70%',
      form: {},
      detailShow: false,
      customerInfo: [],
      invoiceInfo: [],
      payInfo: [],
      sub_third_invoice_confirm: {},
      rules: {
        attachment: [{ required: true, message: '请添加附件', trigger: ['blur', 'change'] }],
        invoice_amount: [{ validator: checkNumber, trigger: 'blur', required: true }],
        reviewer_name: [
          { required: true, message: '请输入开票人', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        reviewer_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        courier_number: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        audit_date: [
          {
            required: true,
            message: '请选择开票日期',
            trigger: 'change'
          }
        ]
      },
      payHeader: [],
      isThousand: false,
      loading: false,
      tenantId: ''
    }
  },
  watch: {
    show: {
      handler(newVal, oldVal) {
        this.detailShow = newVal
      },
      deep: true,
      immediate: true
    },
    detailId: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) this.getDetail(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 保存
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.sub_third_invoice_confirm = []
          this.form.sub_third_invoice_confirm.push(this.sub_third_invoice_confirm)

          this.$http.put('${third}/costcenter/third_invoice_apply/', this.form).then(
            (resp) => {
              if (resp.data.state) {
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.loading = false
                  this.closeDetail(true)
                }, 100)
              }
            },
            (error) => {
              this.loading = false
              reject(error)
            }
          )
        } else {
          this.loading = false

          return false
        }
      })
    },
    //千分位组件值回写
    setVal(keyName, val) {
      this.sub_third_invoice_confirm[keyName] = val
    },

    // 获取详情
    getDetail(id) {
      this.$http.get('${third}/costcenter/third_invoice_apply/' + id).then(
        (resp) => {
          if (resp.data) {
            // 当前记录的所属租户Id
            this.tenantId = resp.data.customer_id
            this.form = resp.data
            this.customerInfo = [
              {
                firstLabel: '发票申请单号',
                firstValue: resp.data.audit_no,
                secondLabel: '客户名称',
                secondValue: resp.data.customer_name
              },
              {
                firstLabel: '联系人',
                firstValue: resp.data.contacts,
                secondLabel: '联系电话',
                secondValue: resp.data.contacts_phone
              },
              {
                firstLabel: '地址',
                firstValue: resp.data.receiver_address,
                secondLabel: '邮箱',
                secondValue: resp.data.receiver_meal
              },
              {
                firstLabel: '申请发票金额',
                firstValue: this.num_formatter(resp.data.apply_amount) + '元',
                secondLabel: '发票类型',
                secondValue: utils.findAllDataDict(resp.data.invoice_type, 'jxfpkplx', this.allDataDict)
              }
            ]
            this.invoiceInfo = [
              {
                firstLabel: '发票抬头名称',
                firstValue: resp.data.invoice_title,
                secondLabel: '纳税人识别号',
                secondValue: resp.data.identity_code
              },
              {
                firstLabel: '开户行及账号',
                firstValue: resp.data.bank_account,
                secondLabel: '地址电话',
                secondValue: resp.data.address_phone
              }
            ]
            this.payHeader = [
              { label: '付款单号', prop: 'payment_no' },
              {
                label: '付款金额',
                prop: 'payment_amount',
                isFormatNumber: true
              },
              {
                label: '确认收款',
                prop: 'pay_amount',
                isFormatNumber: true
              }
            ]
            this.payInfo = resp.data.sub_third_invoice_order
            this.confirmHeader = [
              {
                label: '实际开票金额',
                prop: 'invoice_amount',
                color: 'red',
                isFormatNumber: true
              },
              { label: '开票人', prop: 'reviewer_name' },
              { label: '联系电话', prop: 'reviewer_phone' },
              { label: '快递单号', prop: 'courier_number' },
              { label: '开票日期', prop: 'audit_date' },
              { label: '附件下载', prop: 'attachment', isDownload: true }
            ]
            this.sub_third_invoice_confirm = resp.data.sub_third_invoice_confirm.length
              ? resp.data.sub_third_invoice_confirm[0]
              : {
                  invoice_amount: 0,
                  real_amount_thousand: 0,
                  reviewer_name: '',
                  reviewer_phone: '',
                  audit_date: '',
                  attachment: '',
                  courier_number: ''
                }
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 千分位格式化
    num_formatter(cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },
    //关闭对话框
    closeDetail(isSave) {
      this.detailShow = false
      this.$emit('closeDetailDialog', isSave)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  padding: 0;
  margin: 0;
}
.detailContent {
  padding-left: 20px;
  padding-right: 20px;
}
.eachItem {
  display: flex;
  .label {
    margin-right: 20px;
    flex-shrink: 0;
  }
  p {
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: left;
    line-height: 2;
  }
}
/deep/.el-dialog__body {
  padding-top: 20px;
}
.eachPart {
  margin-bottom: 40px;
  .titlePart {
    display: flex;
    align-content: center;
    margin-bottom: 10px;
    img {
      height: 20px;
    }
    span {
      color: rgba(55, 124, 255, 100);
      font-size: 16px;
      font-weight: bold;
    }
  }
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  /deep/ input::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>
